export default function Configuration() {
  // TODO: map to window events controlling lenses
}
